<p-toast></p-toast>
<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="canalAndTubeWell"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'Water_Source',
		'ApplicationRecieved',
		'TotalArea',
		'Verified_Application',
		'App_Verified_Area',
		'estimateApproved',
		'estimatePending',
        'BOQ_Uploaded',
        'BOQ_Pending',
        'PV_Approved',
        'PV_Pending',
        'DMICADA_Approved',
        'DMICADA_Pending',


        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'CANAL_AND_TUBE_WELL_BASED_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="Water_Source">{{'WATER_SOURCE'| translate}}
                    <p-columnFilter type="text" field="Water_Source" display="menu"></p-columnFilter>
                    <p-sortIcon field="Water_Source"></p-sortIcon>
                </th>
                <th pSortableColumn="ApplicationRecieved">{{'APPLICATION_RECIEVED'| translate}}
                    <p-columnFilter type="text" field="ApplicationRecieved" display="menu"></p-columnFilter>
                    <p-sortIcon field="ApplicationRecieved"></p-sortIcon>
                </th>
                <th pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                    <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalArea"></p-sortIcon>
                </th>
                <th pSortableColumn="Verified_Application">{{'VERIFIED_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="Verified_Application" display="menu"></p-columnFilter>
                    <p-sortIcon field="Verified_Application"></p-sortIcon>
                </th>
                <th pSortableColumn="App_Verified_Area">{{'APP_VERIFIED_AREA'| translate}}
                    <p-columnFilter type="text" field="App_Verified_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="App_Verified_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="estimateApproved">{{'ESTIMATE_APPROVED'| translate}}
                    <p-columnFilter type="text" field="estimateApproved" display="menu"></p-columnFilter>
                    <p-sortIcon field="estimateApproved"></p-sortIcon>
                </th>
                <th pSortableColumn="estimatePending">{{'ESTIMATE_PENDING'| translate}}
                    <p-columnFilter type="text" field="estimatePending" display="menu"></p-columnFilter>
                    <p-sortIcon field="estimatePending"></p-sortIcon>
                </th>
                <th pSortableColumn="BOQ_Uploaded">{{'BOQ_UPLOADED'| translate}}
                    <p-columnFilter type="text" field="BOQ_Uploaded" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQ_Uploaded"></p-sortIcon>
                </th>
                <th pSortableColumn="BOQ_Pending">{{'BOQ_PENDING'| translate}}
                    <p-columnFilter type="text" field="BOQ_Pending" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQ_Pending"></p-sortIcon>
                </th>
                <th pSortableColumn="PV_Approved">{{'PV_APPROVED'| translate}}
                    <p-columnFilter type="text" field="PV_Approved" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_Approved"></p-sortIcon>
                </th>
                <th pSortableColumn="PV_Pending">{{'PV_PENDING'| translate}}
                    <p-columnFilter type="text" field="PV_Pending" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_Pending"></p-sortIcon>
                </th>
                <th pSortableColumn="DMICADA_Approved">{{'DMICADA_APPROVED'| translate}}
                    <p-columnFilter type="text" field="DMICADA_Approved" display="menu"></p-columnFilter>
                    <p-sortIcon field="DMICADA_Approved"></p-sortIcon>
                </th>
                <th pSortableColumn="DMICADA_Pending">{{'DMICADA_PENDING'| translate}}
                    <p-columnFilter type="text" field="DMICADA_Pending" display="menu"></p-columnFilter>
                    <p-sortIcon field="DMICADA_Pending"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-canalAndTubeWell>
            <tr>
                <td>{{canalAndTubeWell.Water_Source}}</td>
                <td>{{canalAndTubeWell.ApplicationRecieved}}</td>
                <td>{{canalAndTubeWell.TotalArea | number:'1.0-2'}}</td>
                <td>{{canalAndTubeWell.Verified_Application}}</td>
                <td>{{canalAndTubeWell.App_Verified_Area | number:'1.0-2'}}</td>
                <td>{{canalAndTubeWell.estimateApproved}}</td>
                <td>{{canalAndTubeWell.estimatePending}}</td>
                <td>{{canalAndTubeWell.BOQ_Uploaded}}</td>
                <td>{{canalAndTubeWell.BOQ_Pending}}</td>
                <td>{{canalAndTubeWell.PV_Approved}}</td>
                <td>{{canalAndTubeWell.PV_Pending}}</td>
                <td>{{canalAndTubeWell.DMICADA_Approved}}</td>
                <td>{{canalAndTubeWell.DMICADA_Pending}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td >{{totalAppReceived | number:'1.0-2'}}</td>
                <td >{{totalArea | number:'1.0-2'}}</td>
                <td >{{totalVerfApp | number:'1.0-2'}}</td>
                <td >{{totalVerfArea | number:'1.0-2'}}</td>
                <td >{{totalEstApproved | number:'1.0-2'}}</td>
                <td >{{totalEstPending | number:'1.0-2'}}</td>
                <td >{{totalBoqUploaded | number:'1.0-2'}}</td>
                <td >{{totalBoqPending | number:'1.0-2'}}</td>
                <td >{{totalPvApproved | number:'1.0-2'}}</td>
                <td >{{totalPvPending | number:'1.0-2'}}</td>
                <td >{{totalDmicadaApproved | number:'1.0-2'}}</td>
                <td >{{totalDmicadaPending | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td >{{grandtotalAppReceived | number:'1.0-2'}}</td>
                <td >{{grandTotalArea | number:'1.0-2'}}</td>
                <td >{{grandTotalVerfApp | number:'1.0-2' }}</td>
                <td >{{grandTotalVerfArea | number:'1.0-2'}}</td>
                <td >{{grandTotalEstApproved | number:'1.0-2'}}</td>
                <td >{{grandTotalEstPending | number:'1.0-2'}}</td>
                <td >{{grandTotalBoqUploaded | number:'1.0-2'}}</td>
                <td >{{grandTotalBoqPending | number:'1.0-2'}}</td>
                <td >{{grandTotalPvApproved | number:'1.0-2'}}</td>
                <td >{{grandTotalPvPending | number:'1.0-2'}}</td>
                <td >{{grandTotalDmicadaApproved | number:'1.0-2'}}</td>
                <td >{{grandTotalDmicadaPending | number:'1.0-2'}}</td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>